import { render, staticRenderFns } from "./BalanceInput.vue?vue&type=template&id=d8524c74&"
import script from "./BalanceInput.vue?vue&type=script&lang=js&"
export * from "./BalanceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports